import React from 'react';

const Help = () => {
  return (
    <div>
      <p>Select a car and move it with arrow keys.</p>
      <p>
        The game will be finished whenever the user exits the red car out of the
        map
      </p>
    </div>
  );
};

export default Help;
